import * as tslib_1 from "tslib";
var AddParticipantModalController = /** @class */ (function () {
    /*@ngInject*/
    function AddParticipantModalController($timeout, modalService, meetingService) {
        this.$timeout = $timeout;
        this.modalService = modalService;
        this.meetingService = meetingService;
        // this.scheduleId = this.resolve.scheduleId;
        // this.jobMatchId = this.resolve.jobMatchId;
        // this.jobMatchObject = this.resolve.jobMatchObject;
        // this.scheduleObject = this.resolve.scheduleObject;
        // this.scheduleType = this.resolve.scheduleType;
        // // this.corpVendorInfo = this.resolve.corpVendorInfo;
        // this.waitingParticipants = this.resolve.waitingParticipants;
        // this.joiningParticipant = this.resolve.joiningParticipant;
        // this.externalMeetingCallId = this.resolve.externalMeetingCallId;
        // //feedback edit enable
        // this.feedbackDetails = this.resolve.feedbackDetails;
        // this.actionType = this.resolve.actionType;
        // //primary host change
        // this.primaryHostChangeDetails = this.resolve.primaryHostChangeDetails;
    }
    AddParticipantModalController.prototype.$onInit = function () {
        var e_1, _a;
        this.scheduleId = this.resolve.scheduleId;
        this.jobMatchId = this.resolve.jobMatchId;
        this.jobMatchObject = this.resolve.jobMatchObject;
        this.scheduleObject = this.resolve.scheduleObject;
        this.scheduleType = this.resolve.scheduleType;
        // this.corpVendorInfo = this.resolve.corpVendorInfo;
        this.waitingParticipants = this.resolve.waitingParticipants;
        this.joiningParticipant = this.resolve.joiningParticipant;
        this.externalMeetingCallId = this.resolve.externalMeetingCallId;
        //feedback edit enable
        this.feedbackDetails = this.resolve.feedbackDetails;
        this.actionType = this.resolve.actionType;
        //primary host change
        this.primaryHostChangeDetails = this.resolve.primaryHostChangeDetails;
        if (this.actionType == "inviteUsers") {
            this.title = "Invite Users";
        }
        else if (this.actionType == "waitingParticipants") {
            this.title = "Participants Waiting";
            try {
                for (var _b = tslib_1.__values(this.waitingParticipants), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var participant = _c.value;
                    participant.isApproved = true;
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            if (this.waitingParticipants.length == 1) {
                this.joiningParticipant = this.waitingParticipants[0];
                this.actionType = "joiningParticipant";
            }
        }
        else if (this.actionType == "joiningParticipant") {
            this.title = "Approval to join meeting";
            this.joiningParticipant.isApproved = true;
        }
        else if (this.actionType == "enableFeedbackEdit") {
            this.title = "Leave meeting";
            this.usersToEditFeedback = this.feedbackDetails.usersToEditFeedback;
            this.externalMeetingCallId = this.feedbackDetails.externalMeetingCallId;
            this.scheduleId = this.feedbackDetails.scheduleId;
            this.readOnly = false;
            this.loadingUsers = true;
            this.setFeedbackEnabledAttendeeId();
        }
        else if (this.actionType == "primaryHostChange") {
            this.title = "Assign Primary Host";
            this.usersToEditFeedback = this.primaryHostChangeDetails.usersToEditFeedback;
            this.externalMeetingCallId = this.primaryHostChangeDetails.externalMeetingCallId;
            this.scheduleId = this.primaryHostChangeDetails.meetingScheduleId;
            this.readOnly = false;
            this.loadingUsers = true;
            this.setPrimaryHostAttendeeId();
        }
        this.callbackObject = { callbackType: 'cancel', entity: {} };
    };
    AddParticipantModalController.prototype.setFeedbackEnabledAttendeeId = function () {
        var _this = this;
        this.loadingUsers = true;
        this.meetingService.getFeedbackEditEnabledAttendeeId(this.externalMeetingCallId, function (data) {
            _this.enableEditForAttendeeId = data.attendeeId;
            _this.previouslyEnabledEditForAttendeeId = data.attendeeId;
            _this._setHosts();
        }, function (error) {
            //do nothing
        });
    };
    AddParticipantModalController.prototype.setPrimaryHostAttendeeId = function () {
        var _this = this;
        this.loadingUsers = true;
        this.meetingService.getPrimaryHostAttendeeId(this.externalMeetingCallId, function (data) {
            _this.enableEditForAttendeeId = data.attendeeId;
            _this.previouslyEnabledEditForAttendeeId = data.attendeeId;
            _this._setHosts();
        }, function (error) {
            //do nothing
        });
    };
    AddParticipantModalController.prototype._setHosts = function () {
        var _this = this;
        this.loadingUsers = true;
        if (this.usersToEditFeedback && this.usersToEditFeedback.length > 0) {
            this.enabledEditForUser = this.usersToEditFeedback.find(function (user) { return user.attendeeId == _this.enableEditForAttendeeId; });
            if (this.enabledEditForUser !== undefined) {
                this.readOnly = this.enabledEditForUser.displayName !== 'You';
                this.previousEnableEditFor = angular.copy(this.enabledEditForUser);
            }
        }
        this.$timeout(function () {
            _this.loadingUsers = false;
        }, 2000);
    };
    AddParticipantModalController.prototype.onUserWhoCanEditFeedbackChange = function () {
        var _this = this;
        this.enabledEditForUser = this.usersToEditFeedback.find(function (user) { return user.attendeeId == _this.enableEditForAttendeeId; });
    };
    AddParticipantModalController.prototype.onPrimaryHostChange = function () {
        var _this = this;
        this.enabledEditForUser = this.usersToEditFeedback.find(function (user) { return user.attendeeId == _this.enableEditForAttendeeId; });
    };
    AddParticipantModalController.prototype.confirmWhoCanEditFeedbackChangeAndLeave = function () {
        var _this = this;
        var message = "Only '" + this.enabledEditForUser.displayName + "' will be allowed to edit the feedback.<br> Do you want to continue?";
        bootbox.confirm({
            closeButton: false,
            title: "<div class='alert alert-warning mb-0'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Confirm</strong></div>",
            message: message,
            className: "zIndex1060",
            backdrop: true,
            onEscape: false,
            buttons: {
                confirm: {
                    label: 'Yes',
                    className: 'btn-info'
                },
                cancel: {
                    label: 'Cancel',
                    className: 'btn-danger'
                }
            },
            callback: function (result) {
                if (result) {
                    _this._approveUserToEditFeedback(true);
                }
                else {
                    _this._selectPreviousUser();
                }
            }
        });
    };
    AddParticipantModalController.prototype.confirmPrimaryHostChangeAndLeave = function () {
        var _this = this;
        var message = "'" + this.enabledEditForUser.displayName + "' will be made the primary host.<br> Do you want to continue?";
        bootbox.confirm({
            closeButton: false,
            title: "<div class='alert alert-warning mb-0'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Confirm</strong></div>",
            message: message,
            className: "zIndex1060",
            backdrop: true,
            onEscape: false,
            buttons: {
                confirm: {
                    label: 'Yes',
                    className: 'btn-info'
                },
                cancel: {
                    label: 'Cancel',
                    className: 'btn-danger'
                }
            },
            callback: function (result) {
                if (result) {
                    _this._approverUserAsPrimaryHost();
                }
                else {
                    _this._selectPreviousUser();
                }
            }
        });
    };
    AddParticipantModalController.prototype._selectPreviousUser = function () {
        var _this = this;
        this.loadingUsers = true;
        this.enabledEditForUser = angular.copy(this.previousEnableEditFor);
        if (this.previousEnableEditFor !== null) {
            this.enableEditForAttendeeId = this.previousEnableEditFor.attendeeId;
        }
        else {
            this.enableEditForAttendeeId = this.previouslyEnabledEditForAttendeeId;
            this.enabledEditForUser = this.usersToEditFeedback.find(function (user) { return user.attendeeId == _this.enableEditForAttendeeId; });
        }
        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        this.$timeout(function () {
            _this.loadingUsers = false;
        }, 1000);
    };
    AddParticipantModalController.prototype._approveUserToEditFeedback = function (isApproved, requesterAttendeeId) {
        var _this = this;
        this.loadingUsers = true;
        var currentUserAttendeeId = this.usersToEditFeedback.find(function (user) { return user.displayName == 'You'; }).attendeeId;
        var enableEditForAttendeeId = isApproved ? this.enableEditForAttendeeId : requesterAttendeeId;
        var attendeeIds = this.usersToEditFeedback.map(function (attendee) { return attendee.attendeeId; });
        var approvalDetails = {
            attendeeId: enableEditForAttendeeId,
            approverId: currentUserAttendeeId,
            meetingScheduleId: this.scheduleId,
            externalMeetingCallId: this.externalMeetingCallId,
            attendeeIds: attendeeIds,
            approved: isApproved
        };
        this.meetingService.giveFeedbackEditApproval(approvalDetails, function (data) {
            if (isApproved) {
                _this.previousEnableEditFor = angular.copy(_this.enabledEditForUser);
            }
            _this.$timeout(function () {
                _this.leaveMeeting();
            }, 2000);
        }, function (error) {
            _this.alertsAndNotificationsService.showToastMessage(error.message, 'danger');
        });
    };
    AddParticipantModalController.prototype._approverUserAsPrimaryHost = function () {
        var _this = this;
        this.loadingUsers = true;
        var currentUserAttendeeId = this.usersToEditFeedback.find(function (user) { return user.displayName == 'You'; }).attendeeId;
        this.primaryHostChangeDetails.newHostAttendeeId = this.enableEditForAttendeeId;
        this.meetingService.makeUserPrimaryHost(this.primaryHostChangeDetails, function (data) {
            _this.$timeout(function () {
                _this.leaveMeeting();
            }, 2000);
        }, function (error) {
            _this.alertsAndNotificationsService.showToastMessage(error.message, 'danger');
        });
    };
    AddParticipantModalController.prototype.leaveMeeting = function () {
        this.callbackObject.callbackType = 'leaveMeeting';
        this.modalInstance.close(this.callbackObject);
    };
    AddParticipantModalController.prototype.closeModal = function () {
        this.modalInstance.close(this.callbackObject);
    };
    AddParticipantModalController.prototype.dismissModal = function () {
        this.modalInstance.dismiss('cancel');
    };
    AddParticipantModalController.prototype.addParticipant = function () {
        this.callbackObject.callbackType = 'add';
        this.callbackObject.entity = angular.copy(this.participant);
        this.modalInstance.close(this.callbackObject);
    };
    AddParticipantModalController.prototype.allow = function () {
        var selectedParticipants = this.waitingParticipants.filter(function (participant) { return participant.isApproved; });
        if (selectedParticipants.length == 0) {
            this.displayNoSelectionMessage = true;
        }
        else {
            var entity = {
                participantDetails: this.waitingParticipants,
                externalMeetingCallId: this.externalMeetingCallId
            };
            this.callbackObject.callbackType = 'addParticipants';
            this.callbackObject.entity = angular.copy(entity);
            this.modalInstance.close(this.callbackObject);
        }
    };
    AddParticipantModalController.prototype.validateParticipant = function () {
        this.displayNoSelectionMessage = this.waitingParticipants.filter(function (participant) { return participant.isApproved; }).length == 0;
    };
    AddParticipantModalController.prototype.allowJoiningParticipant = function () {
        var entity = {
            participantDetails: [this.joiningParticipant],
            externalMeetingCallId: this.externalMeetingCallId
        };
        this.callbackObject.callbackType = 'addParticipants';
        this.callbackObject.entity = angular.copy(entity);
        this.modalInstance.close(this.callbackObject);
    };
    AddParticipantModalController.prototype.disApproveParticipants = function () {
        var e_2, _a;
        if (this.actionType == "waitingParticipants") {
            try {
                for (var _b = tslib_1.__values(this.waitingParticipants), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var participant = _c.value;
                    participant.isApproved = false;
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_2) throw e_2.error; }
            }
            var entity = {
                participantDetails: this.waitingParticipants,
                externalMeetingCallId: this.externalMeetingCallId
            };
            this.callbackObject.entity = angular.copy(entity);
        }
        else if (this.actionType == "joiningParticipant") {
            this.joiningParticipant.isApproved = false;
            var entity = {
                participantDetails: [this.joiningParticipant],
                externalMeetingCallId: this.externalMeetingCallId
            };
            this.callbackObject.entity = angular.copy(entity);
        }
        this.callbackObject.callbackType = 'disApproveParticipants';
        this.modalInstance.close(this.callbackObject);
    };
    return AddParticipantModalController;
}());
AddParticipantModalController.$inject = ['$timeout', 'modalService', 'meetingService'];
import * as TEMPLATE from 'raw-loader!./add-participant-modal.html';
export var AddParticipantModalComponent = {
    selector: 'addParticipantModal',
    component: {
        bindings: {
            modalInstance: "<",
            resolve: "<"
        },
        controller: AddParticipantModalController,
        template: TEMPLATE.default,
    }
};
//# sourceMappingURL=add-participant-modal.component.js.map